import {call, select} from 'redux-saga/effects';
import { URLs } from './urls';
import axios, {AxiosResponse, AxiosRequestHeaders} from 'axios';
import { addAuthHeader } from '../services/auth/authInterceptor';

// Log BASE_URL once on startup for debugging
console.log('🔗 API BASE_URL:', URLs.BASE_URL);

export interface IFetchOptions {
    endpoint: string,
    method:string,
    headers: AxiosRequestHeaders,
    body: any
}

const makeRequest = async({ endpoint, method, headers, body = null} : IFetchOptions ) => {
	const response = await axios.request({		
		url:URLs.BASE_URL + endpoint, 
		method,
		headers,				
        data:body
	});
	return response;
};


function* apiRequest({ endpoint, method, body = null } : any) {
    // Get headers with Keycloak Bearer token (if authenticated)
    const baseHeaders = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    
    const headers : HeadersInit = yield call(addAuthHeader, baseHeaders);

    const response : AxiosResponse = yield call(makeRequest, {		
		endpoint,
		method,
		headers: headers as AxiosRequestHeaders,
		body: body  // Axios auto-serializes to JSON when Content-Type is application/json
	});

	// if (response.status === 401) {
    //      log the user out or reresh token
	// }

	if (response.status == 400 || response.status == 401) {
		
		// handle bad response
		console.error(response);
		throw new Error('not ok api request in apiRequest func');
	}
	return response.data;
}

export {apiRequest};
